exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".invoice-container{\n  padding: 20px;\n  max-width: 500px;\n  margin: auto;\n\n  border: 1px solid;\n}\n.invoice-item-table {\n  width: 100%;\n  border-top: 6px solid;\n  border-bottom: 6px solid;\n}\n\n.payment-summary {\n  padding: 10px 20px 20px 20px;\n  display: flex;\n  justify-content: center;\n  flex-flow: column;\n  align-items: center;\n}\n\n.payment-amount {\n  font-weight: bold;\n  font-size: 18px;\n  text-align: center;\n  border: 1px solid;\n  padding: 10px;\n}\n.invoice-title{\n  margin: auto;\n  margin-top: 100px;\n  text-align: center;\n  padding: 10px 0;\n\n}\n.invoice-header{\n  padding-bottom: 10px;\n}\n\n.invoice-header .row {\n  padding-bottom: 5px;\n}\n\n.invoice-item-table > thead {\n  border-bottom: 1px solid;\n}\n\n\n.invoice-item-table > thead > tr > th {\n  padding: 10px 5px;\n}\n\n.invoice-item-table > tbody > tr > td {\n\n  padding: 10px 5px;\n}\n\n@media screen and (max-width: 768px) {\n.payment-summary{\n  padding-right: 0;\n  padding-left: 0;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/invoice-info-detail/invoice-info-detail.component.css
// module id = 932
// module chunks = 3